//要素を全て取得
const sliders = document.querySelectorAll('.js-swiper');

//繰り返し処理
sliders.forEach((slider) => {
  //要素を取得
  const thumbs = slider.querySelector('.js-swiper-thumbs'),
  main = slider.querySelector('.js-swiper-main');
  
  //サムネイルスライダー
  const swiperThumbs = new Swiper(thumbs, {
    spaceBetween: 5,
    slidesPerView: "auto",
    freeMode: true,
  });
  
  //メインイルスライダー
  const swiperMain = new Swiper(main, {
      effect: "fade",
    loop: true,
      speed: 2500,
      autoplay: {
    delay: 1000,
  },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiperThumbs,
    },
  });
});